import { getImageDataFromWpResponse } from 'utils/transformHelpers';
import { getArticleAttributionFromWpResponse } from 'utils/articleAttributionTransform';
import type {
  ArticleType,
  ArticleTag,
  ImageObj,
  WpArticleAttribution,
  WpImageResponse,
} from 'types';

interface WpArticleAcfValues {
  excerpt?: string;
  featuredImage?: {
    image?: WpImageResponse;
    mobileImage?: WpImageResponse;
  };
  attribution?: WpArticleAttribution;
}

export interface WpArticleResponse {
  title?: string;
  slug: string;
  date?: string;
  tags?: ArticleTag[];
  acf?: WpArticleAcfValues;
}

export default function wpToArticleTransform(article: WpArticleResponse): ArticleType {
  const { acf } = article;
  const featuredImage = getImageDataFromWpResponse(acf?.featuredImage) as {
    image?: ImageObj;
    mobileImage?: ImageObj;
  };
  const attribution = getArticleAttributionFromWpResponse(acf?.attribution);

  return {
    title: article.title || '',
    slug: article.slug,
    excerpt: acf?.excerpt || '',
    date: article.date || '',
    href: `/articles/${article.slug}`,
    ...(article.tags?.length ? { tags: article.tags } : {}),
    ...(featuredImage?.image ? { featuredImage } : {}),
    attribution,
  };
}
